import { Flex } from '@chakra-ui/react'
import { Footer } from '../Footer'
import { Navbar } from '../Navbar'

type LayoutPros = React.PropsWithChildren<unknown>

function Layout({ children }: LayoutPros) {
  return (
    <Flex direction="column" minH="100vh" justify="space-between">
      <Navbar />
      {children}
      <Footer />
    </Flex>
  )
}

export default Layout
